import { useRef, useEffect, useState } from 'react';
import '../index.css'; // Ensure global styles for keyframes

const images = [
  require('../assets/New folder/electricity-1.png'),
  require('../assets/New folder/electricity-2.png'),
  require('../assets/New folder/electricity-3.png'),
];

const images1 = [
    require('../assets/New folder/mobile-1.png'),
    require('../assets/New folder/mobile-2.png'),
    require('../assets/New folder/mobile-3.png'),
]

const images2 = [
    require('../assets/New folder/gas-1.png'),
    require('../assets/New folder/gas-2.png'),
    require('../assets/New folder/gas-3.png'),
]

const images3 = [
    require('../assets/Images/gift-vouchers.jpg')
]

export default function Services() {
  // Animation in-view logic (for fade/slide in)
  const [carouselInView, setCarouselInView] = useState(false);
  const electricityCarouselRef = useRef();
  const [mobileCarouselInView, setMobileCarouselInView] = useState(false);
  const mobileCarouselRef = useRef();
  const [gasCarouselInView, setGasCarouselInView] = useState(false);
  const gasCarouselRef = useRef();
  const [voucherCarouselInView, setVoucherCarouselInView] = useState(false);
  const voucherCarouselRef = useRef();

  // Intersection Observers for fade/slide in
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setCarouselInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (electricityCarouselRef.current) observer.observe(electricityCarouselRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setMobileCarouselInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (mobileCarouselRef.current) observer.observe(mobileCarouselRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setGasCarouselInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (gasCarouselRef.current) observer.observe(gasCarouselRef.current);
    return () => observer.disconnect();
  }, []);

  // Intersection Observer for voucher image carousel
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setVoucherCarouselInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (voucherCarouselRef.current) observer.observe(voucherCarouselRef.current);
    return () => observer.disconnect();
  }, []);

  // Helper to duplicate images for seamless loop
  const getLoopImages = (arr) => [...arr, ...arr];

  return (
    <div className="w-full px-4 sm:px-8 md:px-12 lg:px-28 font-sans bg-black text-white">
      <div className="text-center justify-center mb-4">
        <div className="inline-block bg-gray-900 text-white px-3 py-1 mb-4 rounded text-sm md:text-base">Our Services</div>
        <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">Play Quiz, Earn Points, and Pay Your Bills Instantly!</h2>
        <p className="text-base xs:text-lg text-gray-300 mb-6 max-w-xl mx-auto">
          Play fun quiz games, earn points, and use them to pay your Kerala electricity bill, recharge any prepaid mobile, or pay your gas bill—instantly and hassle-free, all through our app!
        </p>
      </div>
      {/* Electricity Carousel */}
      <section className="flex flex-col md:flex-row items-center justify-center min-h-[40vh] md:min-h-[60vh] bg-black py-8 md:py-12 px-0 md:px-4 gap-6 md:gap-8">
        <div className="w-full md:w-1/2 flex items-center justify-center mb-6 md:mb-0">
          <div
            ref={electricityCarouselRef}
            className={`relative w-full max-w-xs xs:max-w-sm sm:max-w-md h-48 xs:h-60 sm:h-72 md:h-[340px] p-4 xs:p-6 sm:p-8 rounded-xl overflow-hidden bg-gray-900 flex items-center justify-center transition-all duration-700 ${carouselInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className={`flex w-[9999px] h-full ${carouselInView ? 'animate-continuous-carousel' : ''}`}>
              {getLoopImages(images).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Electricity Service"
                  className="w-40 xs:w-56 sm:w-72 md:w-[320px] mx-2 xs:mx-4 h-full object-contain transform transition-transform duration-500 hover:scale-105"
                  draggable={false}
                />
              ))}
            </div>
          </div>
        </div>
        {/* Right: Service Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <div className="inline-block bg-purple-800 text-white px-3 py-1 rounded mb-3 text-sm md:text-base">Electricity Bill Payment</div>
          <h3 className="text-lg xs:text-xl sm:text-2xl md:text-3xl font-semibold mb-2 leading-snug">Play Games, Earn Points, Pay Your KSEB Bill!</h3>
          <p className="text-gray-400 mb-4 text-sm xs:text-base">
            Play fun quiz games, earn points, and use your winnings to pay your Kerala State Electricity Board (KSEB) electricity bill online—directly through our app. Enjoy learning, winning, and paying your bills with your quiz earnings!
          </p>
          <div className="flex flex-wrap gap-2 xs:gap-3 sm:gap-4 justify-center md:justify-start">
            <button className="bg-purple-800 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Play Quiz & Earn Points</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Pay KSEB Bill with Points</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">100% Online & Instant</button>
          </div>
        </div>
      </section>
      {/* Mobile Carousel */}
      <section className="flex flex-col md:flex-row items-center justify-center min-h-[40vh] md:min-h-[60vh] bg-black py-8 md:py-12 px-0 md:px-4 gap-6 md:gap-8">
        {/* Right: Service Content */}
        <div className="w-full md:w-1/2 order-2 md:order-1 text-center md:text-right">
          <div className="inline-block bg-blue-700 text-white px-3 py-1 rounded mb-3 text-sm md:text-base">Mobile Recharge</div>
          <h3 className="text-lg xs:text-xl sm:text-2xl md:text-3xl font-semibold mb-2 leading-snug">Recharge Any Mobile with Your Quiz Points!</h3>
          <p className="text-gray-400 mb-4 text-sm xs:text-base">
            Play quiz games, earn points, and recharge your prepaid mobile of any network—Jio, Airtel, Vi, BSNL, and more—directly through our app. Use your quiz winnings for instant mobile recharges!
          </p>
          <div className="flex flex-wrap gap-2 xs:gap-3 sm:gap-4 justify-center md:justify-end">
            <button className="bg-blue-700 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Play Quiz & Earn Points</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Recharge Any Network</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Instant & Hassle-Free</button>
          </div>
        </div>
        {/* Left: Image Carousel */}
        <div className="w-full md:w-1/2 order-1 md:order-2 flex items-center justify-center mb-6 md:mb-0">
          <div
            ref={mobileCarouselRef}
            className={`relative w-full max-w-xs xs:max-w-sm sm:max-w-md h-48 xs:h-60 sm:h-72 md:h-[340px] p-4 xs:p-6 sm:p-8 rounded-xl overflow-hidden bg-gray-900 flex items-center justify-center transition-all duration-700 ${mobileCarouselInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className={`flex w-[9999px] h-full ${mobileCarouselInView ? 'animate-continuous-carousel' : ''}`}>
              {getLoopImages(images1).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Mobile Service"
                  className="w-40 xs:w-56 sm:w-72 md:w-[320px] mx-2 xs:mx-4 h-full object-contain transform transition-transform duration-500 hover:scale-105"
                  draggable={false}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* Gas Carousel */}
      <section className="flex flex-col md:flex-row items-center justify-center min-h-[40vh] md:min-h-[60vh] bg-black py-8 md:py-12 px-0 md:px-4 gap-6 md:gap-8">
        {/* Left: Image Carousel */}
        <div className="w-full md:w-1/2 flex items-center justify-center mb-6 md:mb-0">
          <div
            ref={gasCarouselRef}
            className={`relative w-full max-w-xs xs:max-w-sm sm:max-w-md h-48 xs:h-60 sm:h-72 md:h-[340px] p-4 xs:p-6 sm:p-8 rounded-xl overflow-hidden bg-gray-900 flex items-center justify-center transition-all duration-700 ${gasCarouselInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className={`flex w-[9999px] h-full ${gasCarouselInView ? 'animate-continuous-carousel' : ''}`}>
              {getLoopImages(images2).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Gas Service"
                  className="w-40 xs:w-56 sm:w-72 md:w-[320px] mx-2 xs:mx-4 h-full object-contain transform transition-transform duration-500 hover:scale-105"
                  draggable={false}
                />
              ))}
            </div>
          </div>
        </div>
        {/* Right: Service Content */}
        <div className="w-full md:w-1/2 text-center md:text-left">
          <div className="inline-block bg-green-700 text-white px-3 py-1 rounded mb-3 text-sm md:text-base">Gas Bill Payment</div>
          <h3 className="text-lg xs:text-xl sm:text-2xl md:text-3xl font-semibold mb-2 leading-snug">Pay Any Gas Bill with Your Quiz Points!</h3>
          <p className="text-gray-400 mb-4 text-sm xs:text-base">
            Play quiz games, earn points, and pay your gas bill for any mobile number and any gas company—HP Gas, Bharat Gas, Indane Gas, and more—directly through our app. Use your quiz winnings for instant gas bill payments!
          </p>
          <div className="flex flex-wrap gap-2 xs:gap-3 sm:gap-4 justify-center md:justify-start">
            <button className="bg-green-700 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Play Quiz & Earn Points</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Pay Any Gas Bill</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Instant & Hassle-Free</button>
          </div>
        </div>
      </section>
      {/* Voucher Carousel */}
      <section className="flex flex-col md:flex-row items-center justify-center min-h-[40vh] md:min-h-[60vh] bg-black py-8 md:py-12 px-0 md:px-4 gap-6 md:gap-8">
        {/* Right: Service Content */}
        <div className="w-full md:w-1/2 order-2 md:order-1 text-center md:text-right">
          <div className="inline-block bg-yellow-600 text-white px-3 py-1 rounded mb-3 text-sm md:text-base">Voucher Deals</div>
          <h3 className="text-lg xs:text-xl sm:text-2xl md:text-3xl font-semibold mb-2 leading-snug">Purchase Vouchers with Your Points!</h3>
          <p className="text-gray-400 mb-4 text-sm xs:text-base">
            Use your earned points to purchase vouchers and unlock the best deals in your local city. Enjoy exclusive offers and save more with every quiz you play!
          </p>
          <div className="flex flex-wrap gap-2 xs:gap-3 sm:gap-4 justify-center md:justify-end">
            <button className="bg-yellow-600 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Buy Voucher with Points</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Best Local Deals</button>
            <button className="bg-gray-900 text-white px-4 py-2 rounded text-xs xs:text-sm sm:text-base">Exclusive Offers</button>
          </div>
        </div>
        {/* Left: Image Carousel */}
        <div className="w-full md:w-1/2 order-1 md:order-2 flex items-center justify-center mb-6 md:mb-0">
          <div
            ref={voucherCarouselRef}
            className={`relative w-full max-w-xs xs:max-w-sm sm:max-w-md h-48 xs:h-60 sm:h-72 md:h-[340px] p-4 xs:p-6 sm:p-8 rounded-xl overflow-hidden bg-gray-900 flex items-center justify-center transition-all duration-700 ${voucherCarouselInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          >
            <div className={`flex w-[9999px] h-full ${voucherCarouselInView ? 'animate-continuous-carousel' : ''}`}>
              {getLoopImages(images3).map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Voucher Service"
                  className="w-40 xs:w-56 sm:w-72 md:w-[320px] mx-2 xs:mx-4 h-full object-contain transform transition-transform duration-500 hover:scale-105"
                  draggable={false}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
// Add to your index.css or global CSS:
/*
@keyframes continuous-carousel {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
.animate-continuous-carousel {
  animation: continuous-carousel 18s linear infinite;
}
*/